import type { TextMatchTransformer } from '@lexical/markdown';
import { $isHeadingNode } from '@lexical/rich-text';
import { $findMatchingParent } from '@lexical/utils';
import { $createLineBreakNode, $isLineBreakNode, LineBreakNode } from 'lexical';
import type { ConversionOnlyTransformer } from './conversion-only';

// A physical newline terminates a Markdown heading. Preserve Shift+Enter as an
// inline break without changing literal <br> text in internal paragraphs/code.
export const HEADING_LINE_BREAK: ConversionOnlyTransformer<TextMatchTransformer> =
  {
    dependencies: [LineBreakNode],
    export: (node) =>
      $isLineBreakNode(node) &&
      $findMatchingParent(node, $isHeadingNode) !== null
        ? '<br>'
        : null,
    importRegExp: /<br\s*\/?>/i,
    regExp: /<br\s*\/?>/i,
    getEndIndex: (node, match) =>
      $findMatchingParent(node, $isHeadingNode) !== null
        ? (match.index ?? 0) + match[0].length
        : false,
    replace: (node) => {
      node.replace($createLineBreakNode());
    },
    type: 'text-match',
    conversionOnly: true,
  };
